export default __webpack_public_path__ + "static/homa-98c2dae96ff1b7b5cdd0ae23599967fd.svg";